// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f99c39b7","732":"a684d122","977":"66a740e8"}[chunkId] + ".chunk.js";
};